import { motion } from "framer-motion";
import { Star, BadgeCheck } from "lucide-react";

export function TestimonialsSection({ testimonials }) {
  if (!testimonials || !testimonials.length) return null;
  return (
    <section id="testimonios" className="py-24 lg:py-32" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }} className="mb-12">
          <span className="text-xs uppercase tracking-[0.25em] text-emerald-400 font-medium">Testimonios</span>
          <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight mt-3">
            Resultados <span className="text-gold-gradient">verificados</span>
          </h2>
        </motion.div>
        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.12 }}
              className="rounded-2xl border border-emerald-500/15 bg-[#0D130F] p-7 flex flex-col"
              data-testid={`testimonial-card-${i}`}
            >
              <div className="flex gap-1 mb-4">
                {Array.from({ length: t.rating || 5 }).map((_, s) => (
                  <Star key={s} className="w-4 h-4 text-yellow-500 fill-yellow-500" />
                ))}
              </div>
              <blockquote className="text-gray-300 leading-relaxed flex-1">“{t.text}”</blockquote>
              <figcaption className="mt-6 flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-emerald-500/15 border border-emerald-500/30 flex items-center justify-center font-display font-bold text-emerald-400">
                  {(t.name || "C")[0]}
                </div>
                <div>
                  <div className="text-sm font-semibold flex items-center gap-1.5">{t.name} <BadgeCheck className="w-3.5 h-3.5 text-emerald-400" /></div>
                  <div className="text-xs text-gray-500">{t.role}</div>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
